import { Skeleton } from "@/components/ui/skeleton";

export function SkeletonCard() {
  return (
    <div className="rounded-2xl bg-card/50 backdrop-blur-sm border border-border/50 p-6 space-y-4">
      <Skeleton className="h-8 w-3/4" />
      <Skeleton className="h-4 w-1/2" />
      <div className="space-y-2 pt-4">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-5/6" />
        <Skeleton className="h-4 w-4/6" />
      </div>
    </div>
  );
}

export function SkeletonHero() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-6 p-8">
      <Skeleton className="h-12 w-64 rounded-full" />
      <Skeleton className="h-20 w-[600px] max-w-full" />
      <Skeleton className="h-6 w-[400px] max-w-full" />
      <div className="flex gap-4 mt-4">
        <Skeleton className="h-12 w-36 rounded-full" />
        <Skeleton className="h-12 w-36 rounded-full" />
      </div>
    </div>
  );
}

export function SkeletonRoute() {
  return (
    <div className="rounded-2xl bg-card/50 backdrop-blur-sm border border-border/50 overflow-hidden">
      <Skeleton className="h-16 w-full" />
      <div className="p-6 space-y-3">
        <Skeleton className="h-5 w-32" />
        <div className="grid grid-cols-2 gap-2">
          {Array.from({ length: 8 }).map((_, i) => (
            <Skeleton key={i} className="h-4 w-24" />
          ))}
        </div>
      </div>
    </div>
  );
}

export function SkeletonImage({ className = "" }: { className?: string }) {
  return (
    <div className={`relative overflow-hidden rounded-2xl bg-card/50 border border-border/50 ${className}`}>
      <Skeleton className="w-full h-full" />
    </div>
  );
}

export function SkeletonGrid({ 
  count = 6, 
  className = "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" 
}: { 
  count?: number; 
  className?: string; 
}) {
  return (
    <div className={className}>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

export function SkeletonPartner() {
  return (
    <div className="rounded-2xl bg-card/50 backdrop-blur-sm border border-border/50 p-6 flex flex-col items-center">
      <Skeleton className="h-16 w-24 rounded-lg mb-4" />
      <Skeleton className="h-5 w-20 mb-2" />
      <Skeleton className="h-4 w-16" />
    </div>
  );
}

export function SkeletonContactCard() {
  return (
    <div className="rounded-2xl bg-card/50 backdrop-blur-sm border border-border/50 p-6 flex flex-col items-center text-center">
      <Skeleton className="h-16 w-16 rounded-2xl mb-4" />
      <Skeleton className="h-6 w-32 mb-2" />
      <Skeleton className="h-4 w-48" />
    </div>
  );
}
